import { getAuthSessionChannel } from '@/utils/auth-session-channel';
import { HOME } from '@/constants/routes';
import { AuthSessionEventTypes, type AuthSessionEventType } from '@/constants/auth';

const AUTH_SESSION_MESSAGE_EVENT = 'message';

export default defineNuxtPlugin((nuxtApp) => {
    const userSession = useUserSessionStore();
    const router = useRouter();
    const authOptions = useRuntimeConfig().public.auth;

    const channel = getAuthSessionChannel();
    if (!channel) {
        return;
    }

    const listener = ({ data: type }: MessageEvent<AuthSessionEventType>) => {
        userSession.init();

        if (type === AuthSessionEventTypes.SignedOut) {
            const currentRoute = router.currentRoute.value;
            if (!currentRoute.meta.auth) {
                return;
            }

            void router.replace({
                path: authOptions.logoutRedirectTo,
                query: { redirect: currentRoute.fullPath }
            });

            return;
        }

        if (
            type === AuthSessionEventTypes.SignedIn &&
            userSession.isAuthenticated &&
            router.currentRoute.value.path === authOptions.logoutRedirectTo
        ) {
            const redirectQuery = router.currentRoute.value.query.redirect;
            const redirect =
                typeof redirectQuery === 'string' && redirectQuery.startsWith('/') && !redirectQuery.startsWith('//')
                    ? redirectQuery
                    : HOME;
            void router.replace(redirect);
        }
    };

    channel.addEventListener(AUTH_SESSION_MESSAGE_EVENT, listener);

    nuxtApp.vueApp.onUnmount(() => channel.removeEventListener(AUTH_SESSION_MESSAGE_EVENT, listener));
});
